import React, { useState, useEffect } from "react";
import { useAuth } from '../../../../../../context/AuthContext';
import { useTranslation } from "react-i18next";
import Swal from 'sweetalert2'
import axios from "axios";

export const AdminCreateSection = () => {
    const { user } = useAuth();
    const { t } = useTranslation()
    const [msg, setMsg] = useState([]);

    const onSubmit = async (e) => {
        e.preventDefault();
        try {
            const headerss = {
                "accept": "*/*",
                'Content-Type': 'application/json',
                'Access-Control-Allow-Credentials': 'false',
                'Authorization': 'Bearer ' + user.token
            }
            let url = "https://api.heryerdeingilizce.com/api/admin/TagManager/Create";
            await axios({
                method: 'Post',
                url: url,
                data: {
                    isDeleted: false,
                    tagName: document.getElementById("tagName").value
                },
                headers: headerss
            }).then(res => {
                console.log(res);
                if (res.status === 200) {
                    if (res.data['success']) {
                        Swal.fire({
                            title: "Başırılı!",
                            icon: "success",
                            confirmButtonText: `Tamam`
                        });
                        document.getElementById("tagName").value = "";
                    }
                    else {
                        setMsg(res.data['message']);
                    }
                }
                else {
                    setMsg("Beklenmedik Bir Hata Oluştu. Tekrar Deneyiniz.");
                }
            });
        } catch (err) {
            setMsg(err.message);
        }
    }

    useEffect(() => {
        (async () => {
        })()

    }, [])
    return (
        <div>
            <h3>{msg}</h3>
            <br />
            <div className="card">
                <div className="card-header d-flex justify-content-center">
                    <h2>{t('createSection')}</h2>
                </div>
                <div className="card-body">
                    <form onSubmit={onSubmit}>

                        <div class="mb-3">
                            <label for="tagName" class="form-label">{t('tagName')}</label>
                            <textarea class="form-control" name="sectionName" id="tagName" required />
                        </div>

                        <div className="d-flex justify-content-center">
                            <button type="submit" class="btn btn-primary"> {t('create')} </button>
                        </div>
                    </form>
                </div>
                <div className="card-footer">

                </div>
            </div>

        </div>
    );
}

export default AdminCreateSection;